let inject = [
  '$scope',
  '$state',
  '$rootScope',
  'SharedService',
  'ngAuthSettings'
];

class CarouselBannerController{
  constructor ($scope, $state, $rootScope, SharedService, ngAuthSettings) {
    this.$state = $state;
    this.$scope = $scope;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;
  }
  
}

CarouselBannerController.$inject = inject;

export default CarouselBannerController;




/** WEBPACK FOOTER **
 ** ./www/components/shared/components/banners/carousel-banner/carousel-banner.controller.js
 **/